export enum FeatureName {
  NAVBAR_UI2 = 'navbar-ui2',
}
